import type { SVGProps } from "react";
export interface BankInterestIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BankInterestIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BankInterestIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.375 9a1.125 1.125 0 0 1 2.25 0v7.375h1.75V9a1.125 1.125 0 0 1 2.25 0v7.375h2.523l.115.006a1.125 1.125 0 0 1 0 2.239l-.115.005H5c-.718 0-1.307.55-1.37 1.25H11l.114.006a1.126 1.126 0 0 1 0 2.238l-.114.006H2.5A1.125 1.125 0 0 1 1.375 21v-1c0-1.417.815-2.642 2-3.238z"
      />
      <path
        fill={color}
        d="M21.204 13.204a1.125 1.125 0 0 1 1.59 1.591l-6.998 7a1.125 1.125 0 0 1-1.59-1.59l6.998-7ZM21 20.127a.62.62 0 0 0-.125.372l.013.126a.6.6 0 0 0 .112.246zm1 .744a.6.6 0 0 0 .112-.246l.014-.126-.014-.124a.6.6 0 0 0-.112-.248zm-7-6.744a.62.62 0 0 0-.126.372l.014.126a.6.6 0 0 0 .113.246zm1 .744a.6.6 0 0 0 .112-.246l.014-.126-.014-.124a.6.6 0 0 0-.112-.248zm4.875-7.368a.87.87 0 0 0-.403-.737l-.113-.061-7.59-3.415a1.88 1.88 0 0 0-1.539 0L3.64 6.705a.88.88 0 0 0-.515.798v.372h17.75zm2.25 12.996a1.625 1.625 0 0 1-3.242.167l-.008-.167.008-.165a1.626 1.626 0 0 1 1.617-1.46l.166.01a1.624 1.624 0 0 1 1.459 1.615m-6-6a1.625 1.625 0 0 1-3.242.167l-.007-.167.007-.165a1.626 1.626 0 0 1 1.617-1.46l.165.01c.82.082 1.46.774 1.46 1.615m6-5.499c0 .621-.504 1.125-1.125 1.125H2A1.125 1.125 0 0 1 .875 9V7.503c0-1.23.721-2.344 1.843-2.849l7.59-3.416a4.13 4.13 0 0 1 3.384 0l7.59 3.416.206.101a3.13 3.13 0 0 1 1.637 2.748z"
      />
    </svg>
  );
}
